import React, { useState, useEffect } from "react";
import axios from "axios";
import { Collapse } from "antd";
import {
  formsIcon,
  customerHappinessIcon,
  downloadServiceIcon,
  feeEstimatorIcon,
  faqsIcon,
  servicesChargesIcon,
} from "../../assets/header/overlay";

//bold arrows
import pathIconBolddark from "../../assets/overlay/nav-icon/bold-black.svg";
import pathIconBoldGreen from "../../assets/overlay/nav-icon/bold-green.svg";
import pathIconBoldBlue from "../../assets/overlay/nav-icon/bold-blue.svg";
// close icon
import closeIconDark from "../../assets/overlay/nav-icon/close-dark.svg";
import closeIconGreen from "../../assets/overlay/nav-icon/close-green.svg";
import closeIconBlue from "../../assets/overlay/nav-icon/close-blue.svg";
// back icons
import backIconDark from "../../assets/overlay/nav-icon/light-arrow-black.svg";
import backIconGreen from "../../assets/overlay/nav-icon/light-arrow-green.svg";
import backIconBlue from "../../assets/overlay/nav-icon/light-arrow-blue.svg";

import "./sidebarmobile.css";
import { NavLink, useNavigate } from "react-router-dom";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import constants from "../../utils/constants"
const { Panel } = Collapse;

const MenuMobileOverlay = ({ toggleMenu }) => {
  const [showLinks, setShowLinks] = useState(true);
  const [showContent, setShowContent] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentPage, setcurrentPage] = useState(
    localStorage.getItem("menuItem")
  );
  const currentLan= localStorage.getItem("settingUplanguage") ?? "en-US";
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  const navigate = useNavigate();
  function handleLinkClick(link) {
    setShowLinks(false);
    setShowContent(link);
  }

  function handleBackClick() {
    setShowLinks(true);
    setShowContent(null);
  }

  const handleClick = (index) => {
    setActiveIndex((prevIndex) => {
      if (prevIndex === index) {
        // If the clicked index is the same as the active index, toggle it off
        return null;
      } else {
        // Otherwise, set the clicked index as the new active index
        return index;
      }
    });
  };

  let withoutServices = [
    // about ASPCL
    {
      text: General?.codeLabels["cm_abt_cmpny"]?.label !== undefined ? General?.codeLabels["cm_abt_cmpny"]?.label : "ABOUT THE COMPANY",
      id: "ABOUT ASPCL",
      link: `${constants.URL.CORPORATE_WEBSITE}home/aboutus/aboutajmansewerage`,
    },
    { text: General?.codeLabels["cm_our_team"]?.label !== undefined ? General?.codeLabels["cm_our_team"]?.label : "Our Team", id: "ABOUT ASPCL", link: `${constants?.URL.CORPORATE_WEBSITE}home/aboutus/ourteam` },
    {
      text:General?.codeLabels["cm_clc_network"]?.label !== undefined ? General?.codeLabels["cm_clc_network"]?.label : "Collection Network",
      id: "ABOUT ASPCL",
      link: `${constants?.URL.CORPORATE_WEBSITE}home/aboutus/collectionnetwork`,
    },
    {
      text: General?.codeLabels["cm_trt_plnt"]?.label !== undefined ? General?.codeLabels["cm_trt_plnt"]?.label : "Treatment Plant",
      id: "ABOUT ASPCL",
      link: `${constants?.URL.CORPORATE_WEBSITE}home/aboutus/treatmentplant`,
    },
    {
      text:General?.codeLabels["cm_cminty_foundation"]?.label !== undefined ? General?.codeLabels["cm_cminty_foundation"]?.label : "Community Care Foundation",
      id: "ABOUT ASPCL",
      link: `${constants?.URL.CORPORATE_WEBSITE}home/aboutus/communitycarefoundation`,
    },
    { text:General?.codeLabels["cm_milestones"]?.label !== undefined ? General?.codeLabels["cm_milestones"]?.label : "Milestones", id: "ABOUT ASPCL", link: `${constants?.URL.CORPORATE_WEBSITE}home/aboutus/milestones` },
    // SUSTAINABILITY
    {
      text: General?.codeLabels["cm_our_sustainability"]?.label !== undefined ? General?.codeLabels["cm_our_sustainability"]?.label : "Our Sustainability Efforts",
      id: "SUSTAINABILITY",
      link: `${constants?.URL.CORPORATE_WEBSITE}home/sustainabilityefforts`,
    },
    {
      text:General?.codeLabels["cm_selectservicelabel"]?.label !== undefined ? General?.codeLabels["cm_selectservicelabel"]?.label : "How can we help you?",
      id: "SUSTAINABILITY",
      link: `${constants?.URL.CORPORATE_WEBSITE}home/sustainability/howcanyouhelp`,
    },
    // MEDIA CENTRE
    {
      text: General?.codeLabels["cm_news_events"]?.label !== undefined ? General?.codeLabels["cm_news_events"]?.label : "News & Events",
      id: "MEDIA CENTRE",
      link: `${constants?.URL.CORPORATE_WEBSITE}home/mediacenter/news&events`,
    },
    {
      text:General?.codeLabels["cm_media_gallery"]?.label !== undefined ? General?.codeLabels["cm_media_gallery"]?.label : "Media Gallery",
      id: "MEDIA CENTRE",
      link: `${constants?.URL.CORPORATE_WEBSITE}home/mediacenter/mediagallery`,
    },
    // REACH US
    {
      text: General?.codeLabels["cm_submit_feedback"]?.label !== undefined ? General?.codeLabels["cm_submit_feedback"]?.label : "Submit Feedback",
      id: "REACH US",
      link: `${constants?.URL.CUSTOMER_PORTAL_NEW}complaint`,
    },
    { text:General?.codeLabels["cm_contact_info"]?.label !== undefined ? General?.codeLabels["cm_contact_info"]?.label : "Contact Info", id: "REACH US", link: `${constants?.URL.CORPORATE_WEBSITE}home/reachus/contactinfo` },
  ];

  const [servicesData, setServicesData] = useState(null);

  useEffect(() => {
    const getServices = async () => {
      try {
        const response = await axios.get(
          `${constants.URL.BASE_URL}ASPCL/web/GetServiceGuide`,
          {
            params: {
              lang: currentLan || "en-US",
            },
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // Check if the response is successful
        if (response.status === 200) {
          const data = response.data; // Access response data
          // Process the retrieved data here
          setServicesData(data);
        }
      } catch (error) {
        // Handle any network or other errors
      }
    };

    getServices();
  }, []);

  

  // For Service Guide PDF
 
  const pdfLink = currentLan=='ar'?`${constants?.URL.CORPORATE_WEBSITE}serviceGuides/ASPCL_Service-Doc_ARPages2025.pdf`:currentLan=="hi"?`${constants?.URL.CORPORATE_WEBSITE}serviceGuides/ASPCL_Service-Doc_HIPages2025.pdf`:`${constants?.URL.CORPORATE_WEBSITE}serviceGuides/ASPCL_Service-Doc_ENPages2025.pdf`;

  function handleDownloadClick(pdfUrl) {
    var xhr = new XMLHttpRequest();
    xhr.open(
      "GET",
      pdfUrl,
      true
    );
    xhr.responseType = "blob";
    xhr.onload = function () {
      if (xhr.status === 200) {
        var blob = xhr.response;
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Service Guide.pdf";
        link.click();
      }
    };
    xhr.send();
  }
  const currentURL = window.location.href;
  const lastItem = currentURL.split("#").pop();
  const loginRegisterHandler = (link) => {
    window.open(link, "_blank");
  };
  return (
    <div className="menu-mobile-overlay">
      <div
        className="menu-content "
        style={{
          backgroundColor: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "",
          color: contrast?.contrastColor ? contrast?.contrastColor : "#101e8e",
        }}
      >
        {showLinks ? (
          <div className="header">
            <div></div>

            <img className="close" src={closeIconBlue} onClick={toggleMenu} />
          </div>
        ) : null}
        <div className="main-content">
          {showLinks ? (
            <div className="links">
              <div
                className="each-link"
                style={{
                  color: "",
                }}
                onClick={() => handleLinkClick("ABOUT ASPCL")}
              >
                <div
                  onClick={() => {
                    setcurrentPage("ABOUT ASPCL");
                    localStorage.setItem("menuItem", "ABOUT ASPCL");
                  }}
                  className={currentPage === "ABOUT ASPCL" ? "active" : ""}
                >
                  {(General?.codeLabels["cm_abt_aspcl"]?.label !== undefined
                    ? General?.codeLabels["cm_abt_aspcl"]?.label
                    : "About aspcl").toUpperCase()}
                </div>

                <img
                  src={pathIconBoldBlue}
                  onClick={handleBackClick}
                  style={{}}
                />
              </div>

              <div
                className="each-link"
                style={{
                  color: "",
                }}
                onClick={() => handleLinkClick("Our Services")}
              >
                <div
                  onClick={() => {
                    localStorage.setItem("menuItem", "OUR SERVICES");
                    setcurrentPage("OUR SERVICES");
                  }}
                  className={currentPage === "OUR SERVICES" ? "active" : ""}
                >
                  {(General?.codeLabels["cm_services"]?.label !== undefined
                    ? General?.codeLabels["cm_services"]?.label
                    : "Our Services").toUpperCase()}
                </div>
                <img
                  src={pathIconBoldBlue}
                  onClick={handleBackClick}
                  style={{}}
                />
              </div>

              <div
                className="each-link"
                style={{
                  color: "",
                }}
                onClick={() => handleLinkClick("SUSTAINABILITY")}
              >
                <div
                  onClick={() => {
                    localStorage.setItem("menuItem", "SUSTAINABILITY");
                    setcurrentPage("SUSTAINABILITY");
                  }}
                  className={currentPage === "SUSTAINABILITY" ? "active" : ""}
                >
                  {(General?.codeLabels["cm_sustainability"]?.label !== undefined
                    ? General?.codeLabels["cm_sustainability"]?.label
                    : "Sustainability").toUpperCase()}
                </div>
                <img
                  src={pathIconBoldBlue}
                  onClick={handleBackClick}
                  style={{}}
                />
              </div>

              <div
                className="each-link"
                style={{
                  color: "",
                }}
                onClick={() => handleLinkClick("MEDIA CENTRE")}
              >
                <div
                  onClick={() => {
                    localStorage.setItem("menuItem", "MEDIA CENTRE");
                    setcurrentPage("MEDIA CENTRE");
                  }}
                  className={currentPage === "MEDIA CENTRE" ? "active" : ""}
                >
                  {(General?.codeLabels["cm_media_center"]?.label !== undefined
                    ? General?.codeLabels["cm_media_center"]?.label
                    : "Media Centre").toUpperCase()}
                </div>
                <img
                  src={pathIconBoldBlue}
                  onClick={handleBackClick}
                  style={{}}
                />
              </div>

              <div
                className="each-link"
                style={{
                  color: "",
                }}
                onClick={() => handleLinkClick("REACH US")}
              >
                <div
                  onClick={() => {
                    localStorage.setItem("menuItem", "REACH US");
                    setcurrentPage("REACH US");
                  }}
                  className={currentPage === "REACH US" ? "active" : ""}
                >
                  {(General?.codeLabels["cm_reach_us"]?.label !== undefined
                    ? General?.codeLabels["cm_reach_us"]?.label
                    : "Reach Us").toUpperCase()}
                </div>
                <img
                  src={pathIconBoldBlue}
                  onClick={handleBackClick}
                  style={{}}
                />
              </div>
            </div>
          ) : (
            <div className="content">
              <div className="header">
                <div style={{ justifyContent: "center", alignItems: "center" }}>
                  <img
                    src={backIconBlue}
                    onClick={handleBackClick}
                    style={{
                      width: "6px",
                    }}
                  />
                  <span style={{ marginInlineStart: "14px" }}>BACK</span>
                </div>
                <div>{currentPage.toUpperCase()}</div>

                <img
                  className="close"
                  src={closeIconBlue}
                  onClick={toggleMenu}
                />
              </div>

              <div className="categories">
                {/* All */}
                <div>
                  <div
                    className={`panel ${activeIndex === 0 ? "active" : ""}`}
                    style={{
                      backgroundColor: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : "",
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "#101e8e",
                    }}
                  >
                    {showContent !== "Our Services" ? (
                      <>
                        <div className="about">
                          {withoutServices
                            .filter((objs) => {
                              return objs.id === showContent;
                            })
                            .map((filterredValues) => {
                              return (
                                <div
                                  onClick={() => {
                                    loginRegisterHandler(filterredValues.link);
                                  }}
                                  className="link"
                                >
                                  <NavLink
                                    to={"#"}
                                    style={{
                                      color: "",
                                    }}
                                  >
                                    {filterredValues.text}
                                  </NavLink>
                                </div>
                              );
                            })}
                        </div>
                      </>
                    ) : (
                      <>
                        <Collapse 
                          expandIcon={({ isActive }) => (
                            <div
                              style={{
                                width: 24,
                                height: 24,
                                fontSize: "20px",
                              }}
                            >
                              {isActive ? "-" : "+"}
                            </div>
                          )}
                        >
                          <Panel
                            style={{
                              backgroundColor: contrast?.contrastBackground
                                ? contrast?.contrastBackground
                                : "",
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : "#101e8e",
                            }}
                            header="FOR TENANTS"
                            key="1"
                          >
                            {servicesData?.data?.map((service) => {
                              const groupTypes = JSON.parse(service?.groupType);
                              if (groupTypes?.includes("tenant")) {
                                const handleNavigation = () => {
                                  window.open(
                                    `${constants?.URL.CORPORATE_WEBSITE}home/ourservices/servicesguide#${service.serviceGuidePageLink}`,
                                    "_blank"
                                  );
                                };

                                return (
                                  <p
                                    key={service?.id}
                                    onClick={handleNavigation}
                                    className="mobile-overly-fortenants-p"
                                  >
                                    <span
                                      className={
                                        lastItem == service.serviceGuidePageLink
                                          ? "active"
                                          : ""
                                      }
                                      style={{
                                        backgroundColor:
                                          contrast?.contrastBackground
                                            ? contrast?.contrastBackground
                                            : "",
                                        color: contrast?.contrastColor
                                          ? contrast?.contrastColor
                                          : "#101e8e",
                                      }}
                                    >
                                      {service?.serviceGuideTitle}
                                    </span>
                                  </p>
                                );
                              }
                              return null;
                            })}
                          </Panel>
                        </Collapse>
                        <Collapse 
                          expandIcon={({ isActive }) => (
                            <div
                              style={{
                                width: 24,
                                height: 24,
                                fontSize: "20px",
                              }}
                            >
                              {isActive ? "-" : "+"}
                            </div>
                          )}
                        >
                          <Panel
                            style={{
                              backgroundColor: contrast?.contrastBackground
                                ? contrast?.contrastBackground
                                : "",
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : "#101e8e",
                            }}
                            header="FOR OWNERS"
                            key="2"
                          >
                            {servicesData?.data?.map((service) => {
                              const groupTypes = JSON.parse(service?.groupType);
                              if (groupTypes?.includes("owner")) {
                                const handleNavigation = () => {
                                  window.open(
                                    `${constants?.URL.CORPORATE_WEBSITE}home/ourservices/servicesguide#${service.serviceGuidePageLink}`,
                                    "_blank"
                                  );
                                };

                                return (
                                  <p
                                    key={service?.id}
                                    onClick={handleNavigation}
                                    className="mobile-overly-fortenants-p"
                                  >
                                    <span
                                      className={
                                        lastItem == service.serviceGuidePageLink
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      {service?.serviceGuideTitle}
                                    </span>
                                  </p>
                                );
                              }
                              return null;
                            })}
                          </Panel>
                        </Collapse>
                        <Collapse 
                          expandIcon={({ isActive }) => (
                            <div
                              style={{
                                width: 24,
                                height: 24,
                                fontSize: "20px",
                              }}
                            >
                              {isActive ? "-" : "+"}
                            </div>
                          )}
                        >
                          <Panel
                            style={{
                              backgroundColor: contrast?.contrastBackground
                                ? contrast?.contrastBackground
                                : "",
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : "#101e8e",
                            }}
                            header="FOR CONSULTANTS"
                            key="3"
                          >
                            {servicesData?.data?.map((service) => {
                              const groupTypes = JSON.parse(service?.groupType);
                              if (groupTypes?.includes("consultant")) {
                                const handleNavigation = () => {
                                  window.open(
                                    `${constants?.URL.CORPORATE_WEBSITE}home/ourservices/servicesguide#${service.serviceGuidePageLink}`,
                                    "_blank"
                                  );
                                };

                                return (
                                  <p
                                    key={service?.id}
                                    onClick={handleNavigation}
                                    className="mobile-overly-fortenants-p"
                                  >
                                    <span
                                      className={
                                        lastItem == service.serviceGuidePageLink
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      {service?.serviceGuideTitle}
                                    </span>
                                  </p>
                                );
                              }
                              return null;
                            })}
                          </Panel>
                        </Collapse>
                        <Collapse 
                          expandIcon={({ isActive }) => (
                            <div
                              style={{
                                width: 24,
                                height: 24,
                                fontSize: "20px",
                              }}
                            >
                              {isActive ? "-" : "+"}
                            </div>
                          )}
                        >
                          <Panel
                            style={{
                              backgroundColor: contrast?.contrastBackground
                                ? contrast?.contrastBackground
                                : "",
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : "#101e8e",
                            }}
                            header="USEFUL LINKS & GUIDES"
                            key="1"
                          >
                            <div className="useful-links">
                              <div className="btn-links">
                                <div
                                  className="btn"
                                  onClick={() => handleDownloadClick(pdfLink)}
                                >
                                  <img src={downloadServiceIcon} />
                                  <span>
                                    {General?.codeLabels["cm_download_srvice"]
                                      ?.label !== undefined
                                      ? General?.codeLabels[
                                          "cm_download_srvice"
                                        ]?.label
                                      : "Download Service Guide"}
                                  </span>
                                </div>
                                <div
                                  className="btn"
                                  onClick={() => {
                                    window.open(
                                      `${constants?.URL.CORPORATE_WEBSITE}home/servicecharges`,
                                      "_blank"
                                    );
                                  }}
                                >
                                  <img src={servicesChargesIcon} />
                                  <span>
                                    {General?.codeLabels["cm_charges_srvice"]
                                      ?.label !== undefined
                                      ? General?.codeLabels["cm_charges_srvice"]
                                          ?.label
                                      : "Services Charges/ Tariff"}
                                  </span>
                                </div>
                                <div
                                  className="btn"
                                  onClick={() => {
                                    window.open(
                                      `${constants?.URL.CORPORATE_WEBSITE}home/ourservices/faq`,
                                      "_blank"
                                    );
                                  }}
                                >
                                  <img src={faqsIcon} />
                                  <span>
                                    {General?.codeLabels["cm_faqs"]?.label !==
                                    undefined
                                      ? General?.codeLabels["cm_faqs"]?.label
                                      : "FAQs"}
                                  </span>
                                </div>
                                <div
                                  className="btn"
                                  onClick={() => {
                                    window.open(
                                      `${constants?.URL.CORPORATE_WEBSITE}home/ourservices/customerhappinesscenter`,
                                      "_blank"
                                    );
                                  }}
                                >
                                  <img src={customerHappinessIcon} />
                                  <span>
                                    {General?.codeLabels[
                                      "cm_customer_happiness"
                                    ]?.label !== undefined
                                      ? General?.codeLabels[
                                          "cm_customer_happiness"
                                        ]?.label
                                      : "Customer Happiness Centers"}
                                  </span>
                                </div>
                                <div
                                  className="btn"
                                  onClick={() => {
                                    window.open(
                                      `${constants?.URL.CORPORATE_WEBSITE}home/ourservices/forms`,
                                      "_blank"
                                    );
                                  }}
                                >
                                  <img src={formsIcon} />
                                  <span>
                                    {General?.codeLabels["cm_form_tenants"]
                                      ?.label !== undefined
                                      ? General?.codeLabels["cm_form_tenants"]
                                          ?.label
                                      : "Forms (For Tenants)"}
                                  </span>
                                </div>
                                <div
                                  className="btn"
                                  onClick={() => {
                                    window.open(
                                      `${constants?.URL.CORPORATE_WEBSITE}connectionfeeestimator`,
                                      "_blank"
                                    );
                                  }}
                                >
                                  <img src={feeEstimatorIcon} />
                                  <span>
                                    {General?.codeLabels["cm_bill_estimator"]
                                      ?.label !== undefined
                                      ? General?.codeLabels["cm_bill_estimator"]
                                          ?.label
                                      : "Connection Fee Estimator"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </Panel>
                        </Collapse>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="footer-buttons">
            <div
              className="quick-pay"
              onClick={() => {
                window.open(`${constants?.URL.CORPORATE_WEBSITE}quickpay`, "_blank");
              }}
              style={{
                backgroundColor: "",
                color: "",
              }}
            >
              {General?.codeLabels["cm_payafriend"]?.label !== undefined
                ? General?.codeLabels["cm_payafriend"]?.label
                : "Quick Pay"}
            </div>
            <div
              className="e-token"
              onClick={() => {
                window.open(`${constants?.URL.CORPORATE_WEBSITE}etoken`, "_blank");
              }}
              style={{
                backgroundColor: "",
                color: "",
              }}
            >
              {General?.codeLabels["cm_eticket"]?.label !== undefined
                ? General?.codeLabels["cm_eticket"]?.label
                : "E-TOKEN"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(MenuMobileOverlay);
